import { ClippingStudioTranscriptTrack } from "./clipping-studio-transcript";
import { ClippingStudioSubtitleEvent } from "./clipping-studio-project";

export abstract class IClippingStudioTranscriptRepository {
  /** Fetch all transcript tracks for a media item. */
  abstract getTranscriptTracks(
    mediaId: number,
  ): Promise<ClippingStudioTranscriptTrack[]>;

  /** Fetch original subtitle segments per language. */
  abstract getSubtitleTracks(
    mediaId: number,
  ): Promise<Record<string, ClippingStudioSubtitleEvent[]>>;

  /** Regenerate transcript from source audio (AI operation). */
  abstract regenerateTranscript(
    mediaId: number,
    language: string,
  ): Promise<ClippingStudioTranscriptTrack>;

  /** Update a single transcript block text. */
  abstract updateTranscriptBlock(
    mediaId: number,
    language: string,
    blockId: number,
    newText: string,
  ): Promise<void>;

  /** Generate subtitles from a transcript track. */
  abstract generateSubtitlesFromTranscript(
    mediaId: number,
    language: string,
  ): Promise<ClippingStudioSubtitleEvent[]>;

  /** Import subtitles from SRT/VTT file content. */
  abstract importSubtitles(
    fileContent: string,
    format: "srt" | "vtt",
  ): Promise<ClippingStudioSubtitleEvent[]>;

  /** Export subtitles to SRT/VTT format. */
  abstract exportSubtitles(
    subtitles: ClippingStudioSubtitleEvent[],
    format: "srt" | "vtt",
  ): Promise<string>;
}
